import '../scss/app.scss'; // Importing SCSS file
import PortfolioLoader from './porfolio-api-call';
 

document.addEventListener('DOMContentLoaded', () => {
            const keyPersonnelItems = document.querySelectorAll('.key-personnel-text');
    function sortPersonnelByName(keyPersonnelItems) {
        // Get all elements with the class 'key-personnel-text'


        if (!keyPersonnelItems.length) {
            console.warn("No personnel items found to sort");
            return;
        }

        // Convert NodeList to an array
        const itemsArray = Array.from(keyPersonnelItems);

        // Function to split full name into [firstName, lastName]
        const splitName = (fullName) => {
            const [firstName, ...rest] = fullName.split(' ');
            const lastName = rest.join(' ');
            return [firstName, lastName];
        };

        // Sort the array by first name, and then by last name if first names are the same
        itemsArray.sort((a, b) => {
            const nameA = splitName(a.querySelector('a').textContent);
            const nameB = splitName(b.querySelector('a').textContent);

            if (nameA[0] === nameB[0]) {
                return nameA[1].localeCompare(nameB[1]);
            }
            return nameA[0].localeCompare(nameB[0]);
        });

        // Get the parent container
        const parentContainer = keyPersonnelItems[0].parentNode;

        // Remove existing items from the parent container
        itemsArray.forEach(item => parentContainer.removeChild(item));

        // Append the sorted items back to the parent container
        itemsArray.forEach(item => parentContainer.appendChild(item));
    }

    if (keyPersonnelItems && keyPersonnelItems?.length > 0) {
        sortPersonnelByName(keyPersonnelItems);
    } else {
        console.warn('No key personnel items found to sort');
    }


    function initializePortfolioGrid() {
  // Use the same selector as the PHP shortcode output: .portfolio-grid
        const portfolioGrid = document.querySelector('.portfolio-grid');
        
       
    if (!portfolioGrid) {
        console.warn("Portfolio grid container ('.portfolio-grid') not found. Portfolio loader will not run.");
        return;
    }

    // Collect all existing portfolio item slugs in the grid
    const existingSlugs = Array.from(portfolioGrid.querySelectorAll('.portfolio-card[data-slug]'))
        .map(item => item.getAttribute('data-slug'))
        .filter(Boolean);

        const { rest_url, nonce, origin } = jainc;
        
        
        

    // Pass the exclude slugs to the PortfolioLoader
    const loader = new PortfolioLoader(
        rest_url + 'jai/v1/portfolio-data',
        '.portfolio-grid',
        existingSlugs,
        nonce,
        origin,
        9 // perPage
    );

    // No need to call loader.init() — page 2 loads automatically after 1s
}

    initializePortfolioGrid();
    

});


 
